import { render, staticRenderFns } from "./cpt-dataV-border-option.vue?vue&type=template&id=73a5c27c&scoped=true"
import script from "./cpt-dataV-border-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-border-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5c27c",
  null
  
)

export default component.exports